export default "__VITE_ASSET__9iND33FX__"